import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    WDSButton,
    TripModes,
    Typography,
    Card,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import Duration from '../../containers/Duration/Duration';
import Endpoint from '../../containers/Endpoint/Endpoint';
import Price from '../../containers/Price/Price';

import styles from './TripCard.scss';

function BookButton(props) {
    const {
        disabled,
        onClick,
        t,
    } = props;

    return (
        <WDSButton
            aria-label={t('book')}
            className={styles.button}
            color="secondary"
            disabled={disabled}
            onClick={onClick}
            size="small"
            fullWidth
        >
            {t('book')}
        </WDSButton>
    );
}

BookButton.propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

BookButton.defaultProps = {
    disabled: false,
};

const LocalizedBookButton = localize(BookButton, 'baseApp');

const TripCard = (props) => {
    const {
        arriveIsNearby,
        carrierName,
        className,
        departIsNearby,
        disabled,
        i18nMoment,
        localizedDepartDateTime,
        onSelect,
        seats,
        selectedFare,
        showTotalPrice,
        t,
        transfers,
        tripId,
        tripModes,
        wheelchairs,
    } = props;

    const onClickAnywhere = () => {
        console.log('clicky');
    };

    const handleSelect = () => {
        return onSelect(tripId);
    };

    return (
        <Card
            className={classNames(
                className,
                styles.container,
            )}
            elevation={2}
            onClick={!disabled
                ? onClickAnywhere
                : undefined}
        >
            <div className={styles.row}>
                <Price
                    className={styles.price}
                    seats={seats}
                    selectedFare={selectedFare}
                    showTotalPrice={showTotalPrice}
                    tripId={tripId}
                    wheelchairs={wheelchairs}
                />
                <TripModes
                    className={styles.tripModes}
                    classes={{
                        icon: styles.tripModesIcon,
                        iconContainer: styles.tripModesIconContainer,
                    }}
                    modes={tripModes}
                />
            </div>
            <div className={styles.summary}>
                <Typography variant="h6">{carrierName}</Typography>
                <Typography variant="body2">
                    <span>{i18nMoment(localizedDepartDateTime).format('ddd, MMM D')}</span>
                    <span className={styles.transfers}>{t('baseApp:includes-transfers', { count: transfers })}</span>
                </Typography>
            </div>
            <div className={styles.endpoints}>
                <Endpoint
                    className={styles.departEndpoint}
                    classes={{ time: styles.time }}
                    duration={<Duration className={styles.duration} tripId={tripId} />}
                    nearby={departIsNearby}
                    transfers={transfers}
                    tripId={tripId}
                    type="depart"
                />
                <Endpoint
                    className={styles.arriveEndpoint}
                    classes={{ time: styles.time }}
                    nearby={arriveIsNearby}
                    tripId={tripId}
                    type="arrive"
                />
            </div>
            <LocalizedBookButton
                disabled={disabled}
                onClick={handleSelect}
            />
        </Card>
    );
};

TripCard.propTypes = {
    arriveIsNearby: PropTypes.bool,
    carrierName: PropTypes.string,
    className: PropTypes.string,
    departIsNearby: PropTypes.bool,
    disabled: PropTypes.bool,
    i18nMoment: PropTypes.func,
    liveCheckIds: PropTypes.shape({
        affiliateId: PropTypes.string,
        allTripIds: PropTypes.arrayOf(PropTypes.string),
        trackingId: PropTypes.string,
    }),
    localizedDepartDateTime: PropTypes.string,
    onSelect: PropTypes.func,
    reviews: PropTypes.shape({
        overall: PropTypes.number,
        review_count: PropTypes.number,
    }),
    seats: PropTypes.number,
    selectedFare: PropTypes.string,
    showTotalPrice: PropTypes.bool,
    t: PropTypes.func.isRequired,
    transfers: PropTypes.number,
    tripId: PropTypes.string,
    tripModes: PropTypes.arrayOf(PropTypes.string),
    wheelchairs: PropTypes.number,
};

TripCard.defaultProps = {
    arriveIsNearby: false,
    className: '',
    departIsNearby: false,
    disabled: false,
    liveCheckIds: {},
    onSelect() { },
    reviews: null,
    seats: 1,
    selectedFare: null,
    showTotalPrice: false,
    transfers: 0,
    tripId: '',
    tripModes: [],
    wheelchairs: 0,
};

export {
    LocalizedBookButton as BookButton,
    TripCard,
};
export default localize(TripCard);
